import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import Login from "./components/auth/Login";
import Dashboard from "./components/dashboard/index";
import OrdenesExt from "./components/dashboard/Dashboard";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import Usuarios from "./components/usuarios/Usuarios";
import Modal from "./components/common/Modal";
import useSessionTimeout from "./hooks/useSessionTimeout";
import Procesos from "./components/procesos";
import SalesOrders from "./components/salesorders";
import MaximosProducto from "./components/maximos/index";
import Results from "./components/results/index";
import Roles from "./components/roles/index";
import Permisos from "./components/permisos/index";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from "react-toastify";
import { useApi } from './hooks/useApi';
import Unauthorized from "./components/permisos/Unauthorized";
import LoginResponse from "./components/auth/LoginResponse";
import Archivos from "./components/archivos/index";
import Log from "./components/salesorders/log";
import EnvioSAP from "./components/salesorders/envioSAP";
import ResumenOrdenesExt from "./components/dashboard/resumen";

const AppRoutes = () => {
  const { user, token, logout, setToken } = useAuth();
  const { post } = useApi();

  const refreshToken = async () => {
    try {
      const data = await post('refreshToken');      
      setToken(data.token);
      localStorage.setItem('token', data.token);
      return data.token;
    } catch (error) {
      console.error('Error al refrescar token', error);
      logout();
    }
  };

  const { showRenewModal, renewSession, logout: sessionLogout, setShowRenewModal } = useSessionTimeout(refreshToken);

  const handleLogout = () => {
    setShowRenewModal(false);
    sessionLogout();
  };

  const handleRenewSession = async () => {
    await renewSession();
    setShowRenewModal(false);
  };

  return (
    <>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/" element={user ? <Navigate to="/dashboard" /> : <Navigate to="/login" />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/login_response" element={<LoginResponse />} />


        {/* Protected routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute >
              <Layout><Dashboard /></Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/ordenes-externas"
          element={
            <ProtectedRoute requiredPermission="hubapp.view">
              <Layout><OrdenesExt /></Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/resumen-ordenes-externas"
          element={
            <ProtectedRoute requiredPermission="hubapp.view">
              <Layout><ResumenOrdenesExt /></Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/usuarios"
          element={
            <ProtectedRoute requiredRole="ADMIN">
              <Layout><Usuarios /></Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/archivos"
          element={
            <ProtectedRoute requiredRole="ADMIN">
              <Layout><Archivos /></Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/configuracion"
          element={
            <ProtectedRoute requiredPermission="config.view">
              <Layout><Procesos /></Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/pedidos-automaticos"
          element={
            <ProtectedRoute requiredPermission="orders.view">
              <Layout><SalesOrders /></Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/pedidos-automaticos/log"
          element={
            <ProtectedRoute requiredPermission="orders.view">
              <Layout><Log /></Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/pedidos-automaticos/traduccion"
          element={
            <ProtectedRoute requiredPermission="orders.view">
              <Layout><SalesOrders /></Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/pedidos-automaticos/envio-sap"
          element={
            <ProtectedRoute requiredPermission="orders.view">
              <Layout><EnvioSAP /></Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/maximos-de-productos"
          element={
            <ProtectedRoute requiredPermission="maximos.view">
              <Layout><MaximosProducto /></Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/resultados-sap"
          element={
            <ProtectedRoute requiredPermission="results.view">
              <Layout><Results /></Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/lista-roles"
          element={
            <ProtectedRoute requiredPermission="roles.view">
              <Layout><Roles /></Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/lista-permisos"
          element={
            <ProtectedRoute requiredPermission="permissions.view">
              <Layout><Permisos /></Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/unauthorized"
          element={
            <Layout>
              <Unauthorized />
            </Layout>
          }
        />


      </Routes>

      {/* Modal de expiración de sesión */}
      <Modal show={showRenewModal} title="Sesión a punto de expirar" onClose={handleLogout}>
        <p className="mb-4 text-gray-700">Tu sesión está a punto de expirar. ¿Deseas renovarla?</p>
        <div className="flex justify-end gap-2">
          <button
            className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded"
            onClick={handleLogout}
          >
            Cerrar sesión
          </button>
          <button
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
            onClick={handleRenewSession}
          >
            Renovar sesión
          </button>
        </div>
      </Modal>

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default AppRoutes;
